import React from 'react';
import "./style.css";
//import { Navigate } from 'react-router-dom';
import MenuLateral from '../MenuLateral'
import FaseNav from '../FaseNav'
import BtnDj from '../../../components/Btn_dj'
import PopMsg from '../../../components/PopMsg'
import Quiz from '../../../components/Quiz'
import TesteFinal from '../../../components/TesteFinal'
//import {ErroAviso} from '../../../components/Erro'
//import Erro404 from "../../../pages/Pagina404";

import {mundoConcluido,faseConcluida} from '../../../hooks/userAddStts'
import { useState } from 'react';

// -----------------------------------------------

import ReactPlayer from 'react-player'


function VideoMain(props) {
  // fazer a validação dos dados do usuario com relação a ja ter assistido o video e informar onde o usuario parou

  /*
    aqui receber:
    MundoInfo:{
      //Informações sobre o Mundo de exibição atual
        -iconeModulo: "https://anima-uploads.s3.amazonaws.com/projects/5ff7c137a976a64adc4f9477/releases/6012d3a2244ab6db86fced07/img/icone-modulo@2x.png",
        -mundoNome: "Mundo 1 - Fase 1",
        -mundoTipo: "Robotica Basica 1",

        -Lista: [
          {  videoId:"",
           VideoInfo: "Bem vindo a primeira Fase do Mundo 1. Preparamos um conteúdo bem legal pra você. Sente-se confortavelmente e clique no play para assistir o vídeo.\nNão tem nada de difícil por aqui. A fase 1 é aquela fase onde aprendemos sobre a dinâmica do jogo, nela fazemos tutorial básico de como jogar e algumas recebemos algumas dicas de como ir avançando no jogo.",
}
        ]
    }
  assistirinfoProps: {
        }
  */
  const [msgErro,setErro] = useState();

  const {mundoData, userData, faseUser, p_mundo, p_fase} = props;
  //const {data: fuData ,mutate:fuMutate} = useFetch(`user/fu${user.id}`);

  //console.log('mundoData: ',mundoData)
  const fase = mundoData.fases.find((fase)=> fase.position===p_fase);

  // const fuData = faseUser.data?.data.fases.length>0 ? faseUser.data.data.fases : [{id:1}]
  const fuData = faseUser.data ? faseUser.data.data.fases : [{id:1}]
  //console.log('fase: ',fase)
  if (faseUser.data){
      //console.log('faseUser ',faseUser)
      //-dj//console.log('faseUser:fases ',fuData)
  }

  // add aqui o btn de ver forms ou ebook fora da plataforma
  //const btn_extra=<BtnDj lista={[{to:"link", name:"forms"},...,{name:"aaaaaa"}]}/>
  //const btn_extra=<BtnDj lista={[{to:"link", name:"forms"}, {name:"aaaaaa"}]}/>
  const [msg_parabens, setParabens] = useState(false)
  const onClick_conc_mundo = () => {!ja_fez_fase && p_fase === mundoData.fases.length && onClick_conc_fase();setParabens(true); mundoConcluido(mundoData.id, userData.id)}
  const onClick_conc_fase = () =>  {faseConcluida(fase.id, userData.id, faseUser.mutate)}

  const faseNavData = {}
  const ja_fez_fase =  fuData.some(fu =>fu.id===fase.id)
  faseNavData.ans = p_fase > 1 ? { to: `/planetas/${p_mundo}/${p_fase-1}`, texto:"<< Voltar"} : undefined
  faseNavData.meio = { to:`/planetas/`, texto:"Voltar para a Missão"}
  // faseNavData.prox  =  ((!ja_fez_fase && mundoData.fases.length===1) || p_fase <= mundoData.fases.length) ? {to: p_fase<mundoData.fases.length ? `/planetas/${p_mundo}/${p_fase+1}` : "#conc", texto:"Avançar >>", onClick:onClick_conc_fase } : undefined
  faseNavData.prox  =  (p_fase !== mundoData.fases.length) ? {to: p_fase<mundoData.fases.length ? `/planetas/${p_mundo}/${p_fase+1}` : "#conc", texto:"Avançar >>", onClick:onClick_conc_fase } : undefined
  faseNavData.conc  =  (p_fase === mundoData.fases.length) ? {to:`#ok`, texto:"✔ Concluir", onClick:onClick_conc_mundo} : undefined

  // se a ultima fase é um quiz, só liberar depois que o quiz for concluido
  // if (p_fase === mundoData.fases.length-1){
  //     if (mundoData.fases[mundoData.fases.length-1].id===31){
  //         faseNavData.prox=undefined;
  //     }
  // }
  // if (mundoData.fases[mundoData.fases.length-1].tipo==="quiz"){
  //     // por hora bloqueando o quiz inicial
  //     if (mundoData.fases[mundoData.fases.length-1].id===31){
  //         faseNavData.conc = undefined;
  //     }
  // }

  if (msgErro){
      faseNavData.prox = undefined;
      faseNavData.conc = undefined;
  }

  return (
    <main className="video-main">

      <div className="corpo">
        <Assistirtop
          iconeMundo={`/img/mundos_logo/${mundoData.icone}`}
          mundoNome={mundoData.titulo}
          mundoTipo={mundoData.subtitulo}
        />
        <Corpo
          fase={fase}
          mundoData={mundoData}
          p_mundo={p_mundo}
          p_fase={p_fase}
          userData={userData}
          fuData={fuData}
          {...{msgErro,setErro}}
        />


        <FaseNav
         {...faseNavData}
        />
        { fase.tipo==="aula" ? (
        <Assistirinfo
         info={fase.aula.info}
        />) : (<></>)
        }
      </div>
      {!!msg_parabens ? (<PopMsg
          titulo="Parabéns!"
          subtitulo="Você concluiu mais uma missão"
          btn_to="/planetas/"
          btn_txt="Voltar para as missões"
      />):<></>}
    </main>
  );
}

export default VideoMain;

/* sub componentes:
  Corpo
  VideoDJ
*/
function Corpo (props){
  const {fase,setErro} = props;

  if (fase.tipo==="aula" && !!fase.aula) {
      const videoData = fase.aula
      const {btns} = videoData
      const btn_extra = !!btns ? <BtnDj lista={btns}/> : <></>
    return(<>
          <div className="assistir-body">
            <Videodj yt_id = {videoData.video_cod}/>
            <MenuLateral {...props} videoData={videoData}/>
          </div>
          {btn_extra}
      </>
    );
  }

  if (fase.tipo==="quiz" && !!fase.quiz) {

    //-dj//console.log("\n\ninvi:Quiz:",fase.quiz)
    return(
        <Quiz quiz_data = {fase.quiz}/>
    );
  }
  if (fase.tipo==="teste_final" && !!fase.teste_final) {

    //-dj//console.log("\n\n-->fase.teste_final:",fase.teste_final)
    return (
        <TesteFinal teste_data = {fase.teste_final}/>
    );
  }
  if (fase.tipo==="forms") {
    return(
      <div className="assistir-body">
        <Formsdj forms_id = {fase.forms_id}/>
      </div>
    );
  }
  if (fase.tipo==="pdf") {
    return(
      <div className="assistir-body">
        <Pdfdj drive_id = {fase.drive_id}/>
        <MenuLateral {...props}/>
      </div>
    );
  }
  setErro('Falha ao carregar')
  return(
    <div className="assistir-body">
        <div className='dj-erro-ao-carregar'>Erro ao carregar informações, nossa equipe de desenvolvimento já foi notificada, atualize a página e, se o erro persistir tente novamente mais tarde</div>
    </div>
  );
}

function Assistirtop(props) {
  const { iconeMundo, mundoNome, mundoTipo } = props;

  return (
    <div className="assistir-top">
      <img alt="iconemodulo" className="icone-modulo" src={iconeMundo} />
      <div className="modulo-titulo">
        <h1 className="mundo-nome archivo-bold-spring-wood-28px">{mundoNome}</h1>
        <div className="mundo-tipo poppins-normal-alto-18px">{mundoTipo}</div>
      </div>
    </div>
  );
}

function Videodj({yt_id}){
    // console.log("video id:",yt_id)
  if (yt_id.length>11){ // google drive
        // a api não comporta videos grandes, infelizmente quebrou minhas pernas
        return (
            <div className="video-dj">
                <ReactPlayer url={`https://drive.google.com/uc?export=download&id=${yt_id}`}
                    width='100%'
                    height='100%'
                    controls={true}

                    id="playerid"
                    title="Video"
                    allowFullScreen={true}
                    allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"

                />
            </div>
      )

        // <iframe
        //     title="Video"
        //     id="playerid"
        //     type="text/html"
        //     src={`https://drive.google.com/file/d/${yt_id}/preview`}
        //     width="100%"
        //     height="100%"
        //     allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture"
        //     frameBorder={0}
        //     allowFullScreen={true}
        // />)
  }
  //import YouTube from 'react-youtube';
  //width="720" height="480"
  //<iframe width="720" height="480" src="https://www.youtube.com/embed/wQxm2KgdAqw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  //<iframe width="720" height="480" src="https://www.youtube-nocookie.com/embed/h-nHdqC3pPs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  return (
    <div className="video-dj">
      <iframe
        title="Video"
        id="playerid"
        type="text/html"
        /*width="100%" height="100%"*/
        src={`https://www.youtube.com/embed/${yt_id}?autohide=2&autoplay=0&rel=0&showinfo=0&color=red&enablejsapi=1&origin=https://inovaonline.vercel.app`}
        // src={`https://www.youtube-nocookie.com/embed/${yt_id}?autohide=2&autoplay=0&rel=0&showinfo=0&color=red&enablejsapi=1&origin=https://inovaonline.vercel.app`}
        rel={0}
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        frameBorder={0}
        allowFullScreen={true}
        >
      </iframe>
    </div>
  )
}
function Formsdj (props){
  const {forms_id} = props;
  //  width="640"
  //  height="4137"
  return (
    <div className="forms-dj">
      <iframe
        title="Formulario"
        src= {`https://docs.google.com/forms/d/e/${forms_id}/viewform?embedded=true`}
        frameborder="0"
        marginheight="0"
        marginwidth="0"

        width="inherit"
        height="inherit"
        margin="0 0 0 0"
        paddingLeft="0"

        >Carregando…
      </iframe>
    </div>
  );
}

function Pdfdj (props) {
  // id do google drive
  // width="600" height="780"
  const {drive_id} = props;

  return (
    <div className="pdf-dj">
      <iframe
        title="Documento"
        src={`https://drive.google.com/file/d/${drive_id}/preview`}
        Style="border: none;">
      </iframe>
    </div>
  );
}
// ---------------------------------------------------
// ---------------------------------------------------

function Assistirinfo(props) {
  const {info} = props;

  return (
    <div className="assistir-info">
      <div className="info-header info-header-fundo">
        <div className="descrio valign-text-middle roboto-bold-alice-blue-28px">Descrição</div>
      </div>
      <div className="text-1 roboto-normal-mercury-28px">{info}</div>
    </div>
  );
}
